// cn.js (or utils.js, whatever you name it)

import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// Backend Base URL (Apne environment variable se match karein)
export const API_BASE_URL = 'http://localhost:5000'; // Ya import.meta.env.VITE_API_URL

/**
 * Converts a database path to a full displayable URL
 * @param {string} path - The path stored in DB (e.g., "/uploads/expenses/abc.jpg")
 * @returns {string} - Full URL (e.g., "http://localhost:5000/uploads/expenses/abc.jpg")
 */
export const getFileUrl = (path) => {
  if (!path) return null;
  
  // Agar path pehle se http se start hota hai (S3 url), to waise hi return karo
  if (path.startsWith('http') || path.startsWith('blob:')) {
    return path;
  }

  // Windows Backslash fix (just in case DB me purana data ho)
  const cleanPath = path.replace(/\\/g, '/');

  // Ensure path starts with /
  const normalizedPath = cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`;

  return `${API_BASE_URL}${normalizedPath}`;
};

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}